import React, { useState, useEffect } from 'react';
import { FiBarChart2, FiTrendingUp, FiTarget, FiAlertCircle } from 'react-icons/fi';
import { useApi } from './useApi';

const TournamentInsights = ({ tournaments, onSelectTournament, selectedTournamentId }) => {
  const { authenticatedFetch } = useApi();
  const [tournamentInsights, setTournamentInsights] = useState(null);
  const [loading, setLoading] = useState(false);
  const [, setError] = useState(null);

  useEffect(() => {
    if (selectedTournamentId) {
      setLoading(true); setError(null);
      const fetchData = async () => {
        try {
          const res = await authenticatedFetch(`/insights/tournament/${selectedTournamentId}/summary`);
          if (res.ok) setTournamentInsights(await res.json());
          else throw new Error('Fetch failed');
        } catch (err) { setError(err.message); }
        finally { setLoading(false); }
      };
      fetchData();
    } else setTournamentInsights(null);
  }, [selectedTournamentId, authenticatedFetch]);

  const RenderTable = ({ title, icon: Icon, data, col, mapping }) => (
    <div className="premium-card insights-leaderboard-card">
      <div className="section-header"><Icon className="section-header-icon" /> {title}</div>
      {data && data.length > 0 ? (
        <div className="table-container">
          <table className="insights-table">
            <thead><tr><th>Player</th><th>{col}</th></tr></thead>
            <tbody>{data.map((item, i) => <tr key={i}>{mapping(item)}</tr>)}</tbody>
          </table>
        </div>
      ) : <div className="empty-state-container"><FiAlertCircle className="empty-state-icon" /><p>No data.</p></div>}
    </div>
  );

  if (!selectedTournamentId) return (
    <div className="empty-state-container" style={{ marginTop: '40px' }}>
      <FiBarChart2 className="empty-state-icon" style={{ opacity: 0.2 }} />
      <p>Select a tournament to view insights</p>
    </div>
  );

  return (
    <div>
      {loading ? <div className="empty-state-container"><p>Loading...</p></div> : (
        tournamentInsights && (
          <div className="tournament-insights-display">
            <div className="stats-grid">
              <div className="stat-card"><span className="stat-label">Avg Stableford</span><span className="stat-value">{tournamentInsights.avg_stableford_points}</span></div>
              <div className="stat-card"><span className="stat-label">Avg Gross</span><span className="stat-value">{tournamentInsights.avg_gross_score}</span></div>
            </div>
            <RenderTable title="Average Points" icon={FiBarChart2} data={tournamentInsights.avg_points_leaderboard} col="Pts" mapping={i => <><td>{i.player_name}</td><td>{i.average_points}</td></>} />
            <RenderTable title="Eagles" icon={FiTarget} data={tournamentInsights.eagles_leaderboard} col="Count" mapping={i => <><td>{i.player_name}</td><td>{i.count}</td></>} />
            <RenderTable title="Birdies" icon={FiTarget} data={tournamentInsights.birdies_leaderboard} col="Count" mapping={i => <><td>{i.player_name}</td><td>{i.count}</td></>} />
            <RenderTable title="Blobs" icon={FiTrendingUp} data={tournamentInsights.blobs_leaderboard} col="Count" mapping={i => <><td>{i.player_name}</td><td>{i.count}</td></>} />
          </div>
        )
      )}
    </div>
  );
};

export default TournamentInsights;
